// extracted by mini-css-extract-plugin
export var container = "styles-module__container___uCcP8";
export var title = "styles-module__title___acgWs";
export var subtitle = "styles-module__subtitle___acvXc";
export var text = "styles-module__text___LJRr4";